/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_AltInputs */

const en_gc_search_guides_gridcraft_online_sections_2_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft sales chart with formatting tools and its source table visible`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 销售图表及其格式工具和源数据表`)
};

/**
* | output |
* | --- |
* | "GridCraft sales chart with formatting tools and its source table visible" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_figure_alt = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_figure_alt(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_figure_alt(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_figure_alt as "gc.search_guides.gridcraft_online.sections.2.figure.alt" }